import { render, staticRenderFns } from "./DateLabel.vue?vue&type=template&id=2f3864a5&scoped=true&"
import script from "./DateLabel.vue?vue&type=script&lang=js&"
export * from "./DateLabel.vue?vue&type=script&lang=js&"
import style0 from "./DateLabel.vue?vue&type=style&index=0&id=2f3864a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3864a5",
  null
  
)

export default component.exports